import { render } from "./BookingHelpDetails.vue?vue&type=template&id=71988599&scoped=true"
import script from "./BookingHelpDetails.vue?vue&type=script&lang=js"
export * from "./BookingHelpDetails.vue?vue&type=script&lang=js"

import "./BookingHelpDetails.vue?vue&type=style&index=0&id=71988599&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71988599"]])

export default __exports__